import React from 'react';
import { Spin } from 'antd';

/**
 * What fills the page while a lazily-loaded screen is being fetched.
 *
 * Every admin route is a `lazy(() => import(...))`, so the first time anybody
 * opens one, the browser has to download its chunk before there is anything to
 * render. This is what stands in for it — and for a long time it stood in for
 * nothing at all.
 *
 * It used to be `h-100`, a percentage height, on a child of a flex item whose
 * own height is resolved by flex rather than stated. A percentage height
 * against an `auto` parent computes to zero, so the box collapsed and the
 * spinner inside it had only its own padding to sit in: a few pixels of grey at
 * the very top of an otherwise empty screen. Opening a customer for the first
 * time therefore looked like a blank page, and reloading "fixed" it only
 * because the chunk was cached by then and the fallback never appeared.
 *
 * `min-height` in viewport units cannot collapse, because it depends on nothing
 * above it. The screen now says it is working.
 */
export default function Loading({ size = 'large' }) {
  return (
    <div
      className='d-flex justify-content-center align-items-center'
      style={{ minHeight: '60vh' }}
      role='status'
      aria-live='polite'
    >
      <Spin size={size} />
    </div>
  );
}
